import { Box } from '@mantine/core';

interface TabsActiveProps {
  width: number;
  height: number;
  left: number;
  initial: boolean;
}

export function TabsActive({ width, left, height, initial }: TabsActiveProps) {
  return (
    <Box
      sx={theme => ({
        width,
        height,
        left,
        background: theme.other.gradients.primary,
        position: 'absolute',
        top: 4,
        transition:
          'all 0.2s cubic-bezier(0.40,0.00,1.00,1.00), width 0.3s cubic-bezier(0.40,0.00,1.00,1.00)',
        ...(initial && {
          transition: 'none',
        }),
        borderRadius: 100,
        zIndex: -1,
      })}
    />
  );
}
